<table *ngIf="dataSource?.length; else noData" class="table-container table" cdk-table [dataSource]="dataSource"
  fixedLayout [ngClass]="{ normal: !isClosedCardSelected, closed: isClosedCardSelected, 'project-view': projectStatus}">
  <ng-container *ngFor="let field of fieldArray; let i = index" [cdkColumnDef]="field.fieldName">
    <th cdk-header-cell *cdkHeaderCellDef>
      <span class="sort-thead" (click)="sortAction(field)">
        <span>{{ field.fieldName }}</span>
        <img *ngIf="field.icon !== ''" [src]="getImageAddress(field)" alt="sort-icon" />
      </span>
    </th>

    <td cdk-cell *cdkCellDef="let element" [ngClass]="{ date: getClass(field.fieldName, element['Date']) }">
      <ng-container *ngIf="approvalStatus; else nonApprovalView">
        <ng-container *ngIf="field.keyType === 'singleKey'">
          <div *ngIf="field.key === 'Date'">
            {{getDateForTicketRow(field.fieldName, element['date']) | shortDate}}
          </div>
          <div *ngIf="field.key === 'finalStatus'">
            <span class="status-chip" [ngClass]="element['status']">
              <span class="status-dot"></span>
              {{ (element['status'] | titlecase) ?? 'N/A'}}
            </span>
          </div>
          <div *ngIf="field.key === 'ticketStatus'">
            <span class="status-chip" [ngClass]="getStatus(element['ticketStatus'])">
              <span class="status-dot"></span>
              {{getStatus(element['ticketStatus'])}}
            </span>
          </div>
        </ng-container>

        <ng-container *ngIf="field.keyType === 'multipleKeys'">
          <div *ngIf="field.fieldName === 'TicketNo'">
            <div class="ticket-number-container">
              <div class="ticket-number">
                <a href="#" (click)="handleClick(element['ticketId']); $event.preventDefault()">
                  {{ '#' + element['ticketNo']! }}
                </a>
              </div>
              <div class="description">
                <span>{{ element['description'] }}</span>
              </div>
            </div>
          </div>
          <div *ngIf="field.fieldName === 'Ticket Raised By'">
            <div class="user-details-container">
              <div class="user-name">
                {{ element['createdBy'] }}
              </div>
              <div class="description">
                {{ element['createdByEmail'] }}
              </div>
            </div>
          </div>
          <div *ngIf="field.fieldName === 'Ticket Assigned To'">
            <div class="user-details-container">
              <div class="user-name">
                {{ element['assignedTo'] }}
              </div>
              <div class="description">
                {{ element['assignedToEmail'] }}
              </div>
            </div>
          </div>
        </ng-container>

      </ng-container>
      <ng-template #nonApprovalView>
        <ng-container *ngIf="workspaceStatus; else projectCheck">
          <ng-container *ngIf="field.keyType === 'singleKey'">
            <div *ngIf="field.key === 'name'" class="table-cell">
              <a href="#" (click)="handleClick(element['workspaceId']); $event.preventDefault()" class="workspace-name">
                {{ element['workspaceName'] }}
              </a>
            </div>
            <div *ngIf="field.key === 'planName'">
              {{ element['plan'] || '-' }}
            </div>
            <div *ngIf="field.key === 'startDate'">
              {{ element['startDate'] ? (element['startDate'] | date:'MMM d, y') : 'N/A' }}
            </div>
            <div *ngIf="field.key === 'endDate'">
              {{ element['endDate'] ? (element['endDate'] | date:'MMM d, y') : 'N/A' }}
            </div>
          </ng-container>
        </ng-container>
        <!-- project -->
        <ng-template #projectCheck>
          <ng-container *ngIf="projectStatus; else clientSection">
            <ng-container *ngIf="field.keyType === 'singleKey'">
              <div *ngIf="field.key === 'clientName'">
                {{ getClientForProjectRow(field.fieldName, element['clientName'])}}
              </div>
              <div *ngIf="field.key === 'name'">
                {{ element['name'] || 'N/A' }}
              </div>
              <div *ngIf="field.key === 'assetLinked'">
                {{ element['assetLinked'] ?? 'N/A' }}
              </div>
              <div *ngIf="field.key === 'createdByUser'">
                {{ element['createdByUser'] || 'N/A' }}
              </div>
              <div *ngIf="field.key === 'createdOn'">
                {{(convertToValidDate(element.createdOn) | date: 'MMM d, y') ?? 'N/A' }}
              </div>
              <div *ngIf="field.key === 'actions'">
                <div class="actions">
                  <img src="assets/14x14/edit_blue.svg" alt="Edit" class="action-icon"
                    (click)="handleProjectEdit(element)" title="Edit Project" />
                  <img src="assets/14x14/delete_red.svg" alt="Edit" class="action-icon"
                    (click)="handleProjectDelete(element)" title="Delete Project" />
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-template>
        <!-- client -->
        <ng-template #clientSection>
           <ng-container *ngIf="clientStatus; else ticketView">
            <ng-container *ngIf="field.keyType === 'singleKey'">
            <div *ngIf="field.key === 'createdAt'">
              {{ (element.client.createdAt | date:'MMM d, y') ?? 'N/A' }}
            </div>
            <div *ngIf="field.key === 'name'">
              {{element.client.clientName ?? 'N/A'}}
            </div>
            <div *ngIf="field.key === 'createdby'">
              {{ element.user.createdByUser || 'N/A' }}
            </div>
            <div *ngIf="field.key === 'editClient'">
                <div class="actions">
                  <img src="assets/14x14/edit_blue.svg" alt="Edit" class="action-icon"
                    (click)="handleClientEdit(element)" title="Edit Client" />
                  <img src="assets/14x14/delete_red.svg" alt="Edit" class="action-icon"
                    (click)="handleClientDelete(element)" title="Delete Client" />
                </div>
              </div>
          </ng-container>
          </ng-container>
        </ng-template>
        <!-- ticket -->
        <ng-template #ticketView>
          <ng-container *ngIf="field.keyType === 'singleKey'">
            <span *ngIf="field.key === 'assetTypes'" class="asset-name-container">
              {{ getName(element) || 'name' }}
            </span>
            <span *ngIf="field.key === 'Status'" class="status-chip" [ngClass]="getStatus(element['status'])">
              <span class="status-dot"></span>
              {{getStatus(element['status'])}}
            </span>

            <div>
              {{
              getDateForTicketRow(field.fieldName, element[field.key]) | shortDate
              }}
              <p class="asset-name-container" *ngIf="canDateBeShown && field.fieldName == 'Date'">
                {{ element["Day"] }}
              </p>
            </div>
            <div *ngIf="field.fieldName === 'Ticket Status'">
              <span class="status-chip" [ngClass]="{
                deferred: element['ticketSubStatus'] == 'DEFERRED',
                Completed: element['ticketSubStatus'] == 'COMPLETED'
              }">
                <span class="status-dot"></span>
                {{ element["ticketSubStatus"] | titlecase }}
              </span>
            </div>
          </ng-container>
          <ng-container *ngIf="field.keyType === 'multipleKeys'">
            <ng-container *ngIf="field.fieldName === 'Ticket No'">
              <div class="ticket-number-container">
                <div class="ticket-details-container">

                  <div class="ticket-number">
                    <a href="#" (click)="handleClick(element['ticketId']); $event.preventDefault()">
                      {{
                      "#" +
                      (element["isExternalTicket"] === true ? "Ext - " : "") +
                      element["TicketNo"]
                      }}
                    </a>
                  </div>
                  <div class="status" [ngClass]="getPriorityClass(element['Priority'])">
                    <span class="priority-text">{{ element['Priority'] }}</span>
                  </div>
                </div>
                <div class="description">
                  <span>{{ element["description"] }}</span>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="field.fieldName === 'Ticket Raised by'">
              <ng-container *ngFor="let key of field.key; let i = index">
                <div class="user-details-container">
                  <div *ngIf="!element['isExternalTicket']">
                    <div class="user-name" *ngIf="key === 'UserName'">
                      {{ element[field.key[i]] }}
                    </div>
                    <div class="description" *ngIf="key === 'UserEmail'">
                      {{ element[field.key[i]] }}
                    </div>
                  </div>
                  <div *ngIf="element['isExternalTicket']">
                    <div class="user-name" *ngIf="key === 'UserName'">
                      {{ element["externalUserName"] }}
                    </div>
                    <div class="description" *ngIf="key === 'UserEmail'">
                      {{ element[field.key[i]] }}
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="field.fieldName === 'Ticket Assigned to'">
              <ng-container *ngFor="let key of field.key; let i = index">
                <div class="user-details-container">
                  <div class="user-name" *ngIf="key === 'AssigneeName'">
                    {{ element[field.key[i]] || "-" }}
                  </div>
                  <div class="description" *ngIf="key === 'AssigneEmail'">
                    {{ element[field.key[i]] || "-" }}
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-template>
      </ng-template>
    </td>
  </ng-container>
  <tr cdk-header-row *cdkHeaderRowDef="HeadArray"></tr>
  <tr cdk-row *cdkRowDef="let row; columns: HeadArray"></tr>
</table>
<ng-template #noData>
  <div class="no-data">
    <app-empty-placeholder imageSrc="{{ placeholderIcon }}" [title]="placeholderTitle"
      [subtitle]="placeholderSubtitle"></app-empty-placeholder>
  </div>
</ng-template>